// Fallback tile for post cards without a cover image.
// Editorial emerald gradient + accent glow + italic title fragment.
export default function PostThumb({ post, className = "aspect-[16/10]" }) {
  if (post.cover_image) {
    return (
      <div className={`${className} overflow-hidden rounded-sm border border-border`}>
        <img
          src={post.cover_image}
          alt={post.title}
          className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500"
        />
      </div>
    );
  }
  const fragment = (post.title || "").split(" ").slice(0, 3).join(" ");
  return (
    <div
      className={`${className} relative overflow-hidden rounded-sm border border-border grain-overlay`}
      data-testid={`post-thumb-fallback-${post.slug}`}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary/85 to-primary/70" />
      <div className="absolute -right-10 -top-10 w-56 h-56 rounded-full bg-accent/25 blur-3xl" />
      <div className="absolute inset-0 flex flex-col justify-between p-5 md:p-6 text-primary-foreground">
        <div className="text-[9px] uppercase tracking-[0.28em] opacity-70">
          {post.category}
        </div>
        <div>
          <div className="font-serif text-xl md:text-2xl italic leading-tight tracking-tight opacity-95">
            “{fragment}…”
          </div>
          <div className="mt-2 text-[9px] uppercase tracking-[0.3em] opacity-55">
            Moneyssance Journal
          </div>
        </div>
      </div>
    </div>
  );
}
